import React from 'react';
import ReactDOM from 'react-dom';
import Levels from './data';
import GameManager from './components/gamemanager';
import { Provider } from "react-redux"
import store from "./store"
import './App.css';

if (typeof window !== 'undefined') {
    window.React = React;
}

ReactDOM.render(
	<Provider store={store}>
	<GameManager levels={Levels} />
	</Provider>,
	document.getElementById('gameview')
)



// WEBPACK FOOTER //
// ./src/index.js